module.exports = __webpack_public_path__ + "static/media/modal-close-button.392ce6eb.svg";